
// src/services/feedbackService.js
import { apiRequest } from './api';

/**
 * Submit general feedback
 * @param {object} feedbackData
 * @returns {Promise<object>}
 */
export async function submitFeedback(feedbackData) {
    const response = await apiRequest('/feedback', {
        method: 'POST',
        body: feedbackData,
        authenticated: true, // ✅ Changed to true to send token if available
    });
    return response;
}

/**
 * Report a quiz question issue
 * @param {object} reportData
 * @returns {Promise<object>}
 */
export async function reportQuizQuestion(reportData) {
    const response = await apiRequest('/feedback/quiz-question', {
        method: 'POST',
        body: reportData,
        authenticated: true, // ✅ Changed to true to send token if available
    });
    return response;
}